import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { ADMIN_ROLES } from '../../../core/constants'
import { TariffsDashboard } from '../../../features/tariffs'
import { TariffDetail, TariffEdit, TariffNew, TariffZones } from '../../../features/tariff-detail'

export const TariffsPage = () => {
  const { role } = useSelector((state) => state.global)

  return (
    <Routes>
      <Route index element={<TariffsDashboard />} />
      <Route path=":tariffId" element={<TariffDetail />} />
      {ADMIN_ROLES[role] && (
        <>
          <Route path="new" element={<TariffNew />} />
          <Route path=":tariffId/edit" element={<TariffEdit />} />
          <Route path=":tariffId/zones" element={<TariffZones />} />
        </>
      )}
      <Route path="*" element={<Navigate to="" replace />} />
    </Routes>
  )
}
